import { useQuery } from "@tanstack/react-query";
import type { PartnerGoalTarget } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/goals/:id/targets — per-(partner, period) target rows.
export function useGoalTargets(goalId: string | undefined) {
  return useQuery<PartnerGoalTarget[], ApiClientError>({
    queryKey: queryKeys.goals.targetsForGoal(goalId ?? ""),
    queryFn: () =>
      apiFetch<PartnerGoalTarget[]>(`/admin/goals/${goalId}/targets`),
    enabled: !!goalId,
  });
}
